<template>
  <div class="manage-banner">
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-input type="textarea" :rows="5" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input type="file" multiple accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onChangeImage" />
        </a-form-model-item>
        <div class="list-image-preview">
          <div v-for="item in listImage" :key="item.id" class="list-image-preview__item">
            <a-button class="button-remove text-danger" @click="removeImage(item)" shape="circle" icon="delete"
              size="small" />
            <img :src="item.url_file" alt="" />
          </div>
        </div>
        <a-form-model-item class="mt-50">
          <a-row type="flex" justify="end">
            <a-button type="primary" :loading="callingAPI" @click="handleSubmit">
              {{ form.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetch,
  update,
  create,
  removeFile
} from "@/services/landing-page/career/career-introduce";
export default {
  name: "WorkEnviromentWorkSpace",
  data() {
    return {
      callingAPI: false,
      form: {
        id: null,
        title: "",
        description: "",
        content: "",
        image: [],
        active: 1,
        post_type: 2,
        type: 6,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },

      listImage: []
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const params = {
          post_type: this.form.post_type,
          type: this.form.type,
          per_page: 1,
        };
        const response = await fetch(params);
        if (response.data.data.length) {
          this.form.id = response.data.data[0].id;
          this.form.title = response.data.data[0].title;
          this.form.content = response.data.data[0].content;
          if (response.data.data[0].recruitment_introduce_file.length) {
            this.listImage = response.data.data[0].recruitment_introduce_file.map((f) => ({
              ...f,
              url_file: `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${f.url_file}`
            }))
          }

        }
      } catch (error) { }
    },

    onChangeImage(e) {
      if (e.target.files.length) {
        Array.from(e.target.files).forEach(element => {
          const url = URL.createObjectURL(element)
          this.listImage.push({
            id: Math.random(),
            url_file: url
          })
        });
        this.form.image.push(...e.target.files)
      }
    },

    async removeImage(item) {
      if (item.id) {
        await removeFile(item.id)
        const index = this.listImage.findIndex((i) => i.id === item.id)
        this.listImage.splice(index, 1)
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            if (!this.listImage.length) {
              this.$message.error("Vui lòng upload ảnh!");
              this.callingAPI = false;
              return;
            }

            const formData = new FormData();
            formData.append("title", this.form.title);
            formData.append("description", '');
            formData.append("content", this.form.content);
            formData.append("active", this.form.active);
            formData.append("type", this.form.type);
            formData.append("post_type", this.form.post_type);

            if (this.form.image.length) {
              Array.from(this.form.image).forEach((file) => {
                formData.append("image[]", file);
              })
            }

            if (this.form.id) {
              formData.append("_method", "PUT");
            }

            let response = null;
            if (this.form.id) {
              response = await update(this.form.id, formData);
            } else {
              response = await create(formData);
            }
            this.callingAPI = false;
            if (response.status == 1) {
              const message = this.form.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            this.callingAPI = false;
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-image-preview {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(25%, 100%), 1fr));
  gap: 30px;

  &__item {
    position: relative;

    img {
      width: 100%;
      object-fit: contain;
    }

    .button-remove {
      position: absolute;
      top: -17px;
      right: -10px;
    }
  }
}</style>